
import * as Common from '../Common/commonConstants';

// Necessary endpoints
export const ENDPOINT_INICIARFLUXO = Common.API_BASE_URL+'/api/Estimativa/IniciarFluxo';
export const ENDPOINT_SESSIONCHECK = Common.API_BASE_URL+'/api/Session/SessionCheck';
export const ENDPOINT_CLEARSESSION = Common.API_BASE_URL+'/api/Session/ClearSession';